import React from 'react';
import moment from 'moment';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const displayDate = (value) =>
  value && moment(value).isValid()
    ? moment(value).format('DD MMMM YYYY')
    : '—';

const displayDateTime = (value) =>
  value && moment(value).isValid()
    ? moment(value).format('DD MMMM YYYY HH:mm')
    : '—';

const displayPrice = (value) => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  const num = Number(value);
  return Number.isFinite(num) ? num.toFixed(2) : display(value);
};

const fileLink = (file) => {
  if (!file?.url) {
    return '—';
  }
  return (
    <a href={file.url} target='_blank' rel='noreferrer' download>
      {file.file_name || file.name || file.url}
    </a>
  );
};

export const getExtrastockOfferViewSections = (
  t,
  item,
  { contractType, statusTypes, getBooleanText } = {},
) => {
  if (!item?.id) {
    return [];
  }

  return [
    {
      title: t('Informazioni Generali'),
      fields: [
        {
          text: t('Outlet Village'),
          value: display(
            item['shopping_centers.title'] ||
              item.company?.shopping_center?.title,
          ),
        },
        {
          text: t('Insegna'),
          value: display(item['companies.title'] || item.company?.title),
        },
        {
          text: t('Unità'),
          value: display(item['extrastocks.title'] || item.extrastock?.title),
        },
        {
          text: t('Tipologia contratto'),
          value: display(contractType?.[item.contract_type] || item.contract_type),
        },
        {
          text: t('Nome richiedente'),
          value: display(item.applicant),
        },
        { text: t('Messaggio'), value: display(item.message) },
        { text: t('Data inizio'), value: displayDate(item.date_from) },
        { text: t('Data fine'), value: displayDate(item.date_to) },
        {
          text: t('Stato'),
          value: display(statusTypes?.[item.status] || item.status),
        },
      ],
    },
    {
      title: t('Allegato'),
      fields: [
        { text: t('Verbale di consegna'), value: fileLink(item.rent_file) },
        { text: t('Verbale di riconsegna'), value: fileLink(item.end_rent_file) },
        { text: t('Hot firmato'), value: fileLink(item.hot_file_signed) },
        { text: t('Contratto'), value: fileLink(item.contract_file) },
      ],
    },
    {
      title: t('Contratto'),
      fields: [
        { text: t('Ragione sociale'), value: display(item.legal_name) },
        { text: t('Data richiesta'), value: displayDateTime(item.offer_date) },
        { text: t('Price'), value: displayPrice(item.price) },
        {
          text: t('Contratto - Canone utenze mensili'),
          value: displayPrice(item.consumption_price),
        },
        { text: t('Note contratto'), value: display(item.comment) },
        {
          text: t('Waiting list'),
          value:
            item.waiting_list === true || item.waiting_list === false
              ? getBooleanText?.(item.waiting_list) ?? String(item.waiting_list)
              : display(item.waiting_list),
        },
      ],
    },
  ];
};
